import React from 'react'
import PropTypes from 'prop-types'
import BooleanFilter from './BooleanFilter'

const CarDriveWheels = ({ queryKey, onChange, currentQuery }) => {
  return (
    <BooleanFilter
      label="Fyrhjulsdrift"
      queryKey={queryKey}
      currentQuery={currentQuery}
      onChange={onChange}
      value="1"
    />
  )
}

export default CarDriveWheels

CarDriveWheels.propTypes = {
  queryKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  currentQuery: PropTypes.object.isRequired,
}
